import styles from "./MHomepage.module.scss"

import ImagePlaceHolderPng from "../assets/images/Image_Placeholder.png"
import servicePng from "../assets/images/service.png";
import readMorePng from "../assets/images/readmore.png"
import bgWhyUs from "../assets/images/bg_wu.png"
import bgMeetJennyPng from "../assets/images/bg__mjl.png"
import PhonePng from "../assets/images/Phone.png"
import WechatLogoPng from "../assets/images/WechatLogo.png"
import EnvelopeSimplePng from "../assets/images/EnvelopeSimple.png"
import MapPinPng from "../assets/images/MapPin.png"
import footerLogoPng from "../assets/images/foot_logo.png"
import logoPng from "../assets/images/logo.png"
import welcome1Png from "../assets/images/bg_p1.png"
import Header from "../components/header/MHeader";
import googleMaps from "../../../pages/google-maps";
import { CSSProperties, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import services from "../../../pages/service/services";
import MFooter from "../components/footer/MFooter";

import indictorIcon from "../assets/images/indictor.png"
import activateIndictorIcon from "../assets/images/indictor_activated.png"


export default () => {

    useEffect(() => {
        document.scrollingElement?.scrollTo({top: 0, behavior: "smooth"})
    })

    return (
        <div className={styles['homepage']}>
            <Header activateIdx={0}/>
            <Welcome/>
            <MeetJennyLiu/>
            <WhatOurClientsSay/>
            <OurTrack/>
            <OurService/>
            <WhyUs/>
            <CreateYourAccount/>
            <MFooter/>
        </div>
    )

}


const Welcome = () => {
    return (<WelcomeP1/>)
}

const WelcomeP1 = () => {

    return (
        <div className={styles['welcome__p1']}>
            <img src={welcome1Png} className={styles['welcome__p1__bg']}/>
            <div className={styles['welcome__p1__box-wrapper']}>
                <div className={styles['welcome__p1__box']}>
                    <div className={styles['welcome__p1__title']}>
                        Supporting <span className={styles['welcome__p1__title_hl']}>Immigrant Dreams</span> with Excellus Law
                    </div>
                    <div className={styles['welcome__p1__action']}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['welcome__p1__action__a']}>Schedule A Consultation</a></div>
                </div>
            </div>
        </div>
    )
}

const WhatOurClientsSay = () => {

    const [reviews, setReviews] = useState<any[]>([])
    

    const [page, setPage] = useState<number>(1)
    const [style, setStyle] = useState<CSSProperties>({})

    const changePage = (p: number) => {
        setPage(p)
    }

    const getPages = () => {
        if(reviews.length > 6){
            return [1, 2, 3]
        }else if(reviews.length > 3){
            return [1, 2]
        }{
            return [1]
        }
    }
    
    const renderIndictor = () => {

        return (
            <div className={styles['wocs__indictor']}>
                {
                    getPages().map(p => {
                        return (
                            <div className={styles['wocs__indictor__item']} onClick={() => changePage(p)}>
                                <img src={page == p?indictorIcon:activateIndictorIcon} className={'wocs__indictor__item__icon'}/>
                            </div>
                        )
                    })
                }
                
            </div>
        )
    }

    useEffect(() => {
        googleMaps.getReviews().then(setReviews)
    }, [])

    useEffect(() => {

        if(page == 1){
            setStyle({})
        }else{
            const height = document.querySelector("#wocs__comments")?.getBoundingClientRect().height as number
            const transitionY = - (page - 1) * height
            setStyle({
                transform: `translateY(${transitionY}px)`
            })
        }

    }, [page])

    return (
        <div className={styles["wocs"]}>
            <div className={styles["wocs__title"]}>
                <div className={styles["wocs__title__main"]}>What our clients say</div>
                <div className={styles["wocs__title__sub"]}>Why leading clients choose us</div>
            </div>
            <div  className={styles["wocs__comments"]} style={style}>
                {
                    reviews.slice(0, 3).map(review => (
                        <div className={styles["wocs__comment"]}>
                            <div className={styles["wocs__comment__content"]}>
                            {review.text}
                            </div>
                            <div className={styles["wocs__comment__profile"]}>
                                <img src={review.avatar??ImagePlaceHolderPng} className={styles["wocs__comment__profile__avatar"]}></img>
                                <div className={styles["wocs__comment__profile__name"]}>
                                {review.name}
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* <div id="wocs__comments" className={styles["wocs__comments__swiper"]}>
                
            </div> */}
            {/* {renderIndictor()} */}
        </div>
    )

}

const OurTrack = () => {

    return (
        <div className={styles["ot"]}>
            <div className={styles["ot__title"]}>Our Track Record in Numbers</div>
            <div className={styles["ot__stats"]}>
                <div className={styles["ot__stat"]}>
                    <div className={styles["ot__stat__number"]}>15+</div>
                    <div className={styles["ot__stat__title"]}>
                        <div className={styles["ot__stat__title__main"]}>Years of experience</div>
                        <div className={styles["ot__stat__title__content"]}>Over a decade of dedicated expertise in immigration, helping clients navigate complex legal processes with confidence and ease.</div>
                    </div>
                </div>
                <div className={styles["ot__stat"]}>
                    <div className={styles["ot__stat__number"]}>3,000+</div>
                    <div className={styles["ot__stat__title"]}>
                        <div className={styles["ot__stat__title__main"]}>Approved Cases</div>
                        <div className={styles["ot__stat__title__content"]}>Proven success in securing immigration approvals, with thousands of clients achieving their residency and citizenship goals through our trusted guidance.</div>
                    </div>
                </div>
            </div>
        </div>
    )

}

const OurService = () => {


    const navigate = useNavigate()

    return (
        <div className={styles['os']}>
            <div className={styles['os__title']}>Our Service</div>
            <div className={styles['os__services']}>
                {
                    services.map(service => {
                        return (
                            <div className={styles["os__service"]}>
                                <img className={styles["os__service__icon"]} src={service.icon}></img>
                                <div className={styles["os__service__title"]}>{service.title}</div>
                                <div className={styles["os__service__readmore"]} onClick={() => navigate(`/service/${service.id}`)}>
                                    <div className={styles["os__service__readmore__label"]} >Read more</div>
                                    <img className={styles["os__service__readmore__icon"]} src={readMorePng}/>
                                </div>
                            </div>
                        )
                    })
                }
                            
            </div>
        </div>
    )

}

const WhyUs = () => {

    return (
        <div className={styles['wu']}>
            <div className={styles['wu__title__main']}>
            Why Us
            </div>
            <div className={styles['wu__title__content']}>
            <h3>Expertise You Can Trust</h3>
            <p>
                Led by attorney Jenny Liu, Excellus Law, APC brings over a decade of specialized immigration experience, handling cases across the spectrum from business and family immigration to complex EB-1, EB-2, EB-3, EB-5, and National Interest Waivers. Jenny's deep knowledge of U.S. immigration law ensures clients receive expert guidance tailored to their specific needs.
            </p>

            <h3>Client-Centered Solutions</h3>
            <p>
                At Excellus Law, we understand that each client's situation is unique. We take the time to listen, analyze, and provide customized solutions that best meet individual and business goals. Our client-centered approach means that we prioritize your needs, keeping you informed and involved every step of the way.
            </p>

            <h3>Commitment to Excellence and Integrity</h3>
            <p>
                We uphold the highest standards of integrity, transparency, and professionalism in all our services. Jenny Liu and the Excellus Law team are dedicated to achieving positive results, advocating tirelessly for clients while maintaining clear and open communication to ensure that our clients understand each stage of their case.
            </p>

            <h3>Comprehensive Services Beyond Immigration</h3>
            <p>
                Excellus Law is more than just an immigration firm. With expertise in trademark registration, contract review, and U.S. company incorporation, we provide holistic legal solutions to help individuals and businesses thrive. Whether you're pursuing a visa, seeking to protect intellectual property, or establishing a business, our firm offers the experience and insight you need.
            </p>

            <h3>A Proven Track Record of Success</h3>
            <p>
                Over the years, Jenny Liu has successfully represented clients in a wide array of immigration matters, including high-stakes EB cases, Diversity Visa processes, and the PERM labor certification with the Department of Labor. Our proven track record gives clients the peace of mind that they are working with a firm committed to achieving the best outcomes.
            </p>

            <h3>Dedication to Making Your Goals a Reality</h3>
            <p>
                We recognize the significance of your legal journey and are dedicated to making your aspirations a reality. At Excellus Law, APC, we're more than just your attorneys; we're your trusted partners, working diligently to help you succeed every step of the way.
            </p>
            </div>
            <img src={bgWhyUs} className={styles['wu__bg']}></img>
        </div>
    )
}

const MeetJennyLiu = () => {

    return (
        <div className={styles['mjl']}>
            <div className={styles['mjl__title__main']}>
            Meet Jenny Liu
            </div>
            <div className={styles['mjl__title__content']}>
                <p>
                    Jenny Liu is an accomplished attorney with over a decade of experience dedicated to immigration law, adeptly guiding clients through the complexities of U.S. business and family immigration. She holds a Bachelor of Law degree from Southwest University of Political Science and Law in Chongqing, China, as well as both an LL.M. and a Juris Doctor from the University of Missouri-Kansas City. Since being admitted to the California State Bar in 2012, Jenny has earned a distinguished reputation for her expertise in handling intricate cases, including EB-1, EB-2, EB-3, EB-5, and National Interest Waivers, as well as non-immigrant visas like H-1B, L-1, O-1, E-2, and TN, etc.
                </p>

                <p>
                    Jenny is also well-versed in the PERM labor certification process with the Department of Labor (DOL) and other employment-based visas, ensuring her clients meet every regulatory requirement for U.S. work authorization. Her practice also spans Diversity Visa processes, naturalization, and mandamus actions, demonstrating her versatility and dedication across the immigration spectrum. Beyond immigration services, she brings valuable knowledge in trademark registration, contract review, and U.S. company incorporation, making her a trusted legal advisor in both immigration and business matters.
                </p>

                <p>
                    As the founder of Excellus Law, APC, Jenny's commitment to providing effective, client-centered solutions underscores her dedication to helping individuals and businesses navigate their legal journeys with confidence and success.
                </p>
            </div>
            <img src={bgMeetJennyPng} className={styles['mjl__bg']}></img>
        </div>
    )
}

const CreateYourAccount = () => {

    return (
        <div className={styles['cya']}>
            <div className={styles['cya__title']}>Start your immigration journey with our experts today!</div>
            <div className={styles['cya__action']}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['cya__action__a']}>Schedule A Consultation</a></div>
        </div>
    )
}

